import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'carrier-list',
  templateUrl: './carrier-list.component.html',
  styleUrls: ['./carrier-list.component.scss']
})
export class CarrierListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
